// extracted by mini-css-extract-plugin
export default {"label":"CodeField_label__h6upf","field":"CodeField_field__P8mKk","text":"CodeField_text__w1lz+"};